import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import DealerGroup from 'models/dealerManagement/dealerGroup/Model.DealerGroup';
import Distributor from 'models/sales/distributor/Model.Distributor';
import { useDealerProvider } from '../Dealer.Hooks';
import Theme from 'assets/themes/Theme.Common';

export default function DealerFilters() {
  const { lang } = getLocales();
  const { isDealer, isDistributor, user } = useAuthStore();
  const { listApi } = useDealerProvider();
  const distributorListApi = useApi({ action: Distributor.list, wait: isDealer || isDistributor });
  const dealerGroupListApi = useApi({
    action: DealerGroup.list,
    body: { distributorId: isDistributor && user?.distributorId ? [user.distributorId] : undefined },
    wait: isDealer,
  });

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      filters={listApi.body}
      onFilter={(newFilters) => listApi.execute({ ...newFilters, offset: 0 })}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      onReset={listApi.reset}
      onOpen={() => {
        if (!listApi.payload) listApi.execute();
        if (!distributorListApi.payload && !isDealer && !isDistributor) distributorListApi.execute((body) => body);
        if (!dealerGroupListApi.payload && !isDealer) dealerGroupListApi.execute((body) => body);
      }}
      render={({ tempFilters, setFilters }) => {
        const dealerGroups =
          dealerGroupListApi?.payload?.data?.filter(
            (item) => !tempFilters?.distributorId?.length || tempFilters.distributorId.includes(item.distributorId)
          ) ?? [];

        return (
          <>
            {!isDealer && !isDistributor && (
              <SelectInput
                name="distributorId"
                label={lang.distributors}
                data={distributorListApi?.payload?.data?.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect
                value={tempFilters?.distributorId}
                disabled={!distributorListApi?.payload?.data?.length}
                onChange={({ distributorId }) =>
                  setFilters({
                    ...tempFilters,
                    distributorId,
                    dealerGroupId: tempFilters?.dealerGroupId?.filter((id) =>
                      dealerGroupListApi?.payload?.data?.some(
                        (dealerGroup) =>
                          dealerGroup.id === id &&
                          (!distributorId?.length || distributorId.includes(dealerGroup.distributorId))
                      )
                    ),
                  })
                }
                icon={<Icon class="fas-cloud" />}
              />
            )}
            {!isDealer && (
              <SelectInput
                name="dealerGroupId"
                label={lang.dealerGroup}
                data={dealerGroups.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect
                value={tempFilters?.dealerGroupId}
                disabled={!dealerGroups.length}
                onChange={({ dealerGroupId }) => setFilters({ ...tempFilters, dealerGroupId })}
                icon={<Icon class="fas-cloud" />}
              />
            )}
            <CheckInput
              name="isInactive"
              label={lang.isInactive}
              class={inputStyles.check.switch + ' formInput'}
              value={tempFilters?.isInactive}
              onChange={({ isInactive }) => setFilters({ ...tempFilters, isInactive: Boolean(isInactive) })}
              htmlElementProps={{ title: tempFilters?.isInactive ? lang.disable : lang.enable }}
              style={{ marginTop: Theme.Size.M, alignSelf: 'center' }}
            />
            <CheckInput
              name="hasLegacyId"
              label={lang.hasLegacyId}
              class={inputStyles.check.switch + ' formInput'}
              value={tempFilters?.hasLegacyId}
              onChange={({ hasLegacyId }) => setFilters({ ...tempFilters, hasLegacyId: Boolean(hasLegacyId) })}
              htmlElementProps={{ title: tempFilters?.hasLegacyId ? lang.disable : lang.enable }}
              style={{ marginTop: Theme.Size.M, alignSelf: 'center' }}
            />
            <CheckInput
              name="hasDealerDocuments"
              label={lang.hasDealerDocument}
              class={inputStyles.check.switch + ' formInput'}
              value={tempFilters?.hasDealerDocuments}
              onChange={({ hasDealerDocuments }) =>
                setFilters({ ...tempFilters, hasDealerDocuments: Boolean(hasDealerDocuments) })
              }
              htmlElementProps={{ title: tempFilters?.hasDealerDocuments ? lang.disable : lang.enable }}
              style={{ marginTop: Theme.Size.M, alignSelf: 'center' }}
            />
          </>
        );
      }}
    />
  );
}
